<template>
  <div class="p-12"></div>
</template>

<script>
import { accountComputed } from '@/store/helper';

export default {
  computed: {
    ...accountComputed,
    homeLink() {
      if (!this.account.navigation) {
        return null;
      }

      let home = null;
      this.account.navigation.some((group) => {
        return group.items.some((link) => {
          if (['accounts.show', 'clients.home', 'organizations.home'].includes(link.name)) {
            home = link;
            return true;
          }

          return false;
        });
      });

      return home;
    },
  },

  mounted() {
    if (
      this.$route.path.startsWith('/accounts') === false ||
      !this.homeLink ||
      this.homeLink.name === 'accounts.show'
    ) {
      return;
    }

    if (this.homeLink.name === 'clients.home') {
      window.location.replace(`/c/${this.account.id}`);
    }

    if (this.homeLink.name === 'organizations.home') {
      window.location.replace(`/o/${this.account.id}`);
    }
  },
};
</script>
